import { tsValidateArray, tsValidateEnum, tsValidateResult, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { EncounterFeedSource, EncounterFeedType } from './types.js';
import { AdvisorRuntimeIDBGroup, ConsiderationGroupEnum, Validator_EncounterId } from '@app/advisor-shared';
const Validator_EncounterFeed_Base = {
    ...Validator_EncounterId,
    providerId: tsValidateUniqueId,
    triggeredBy: tsValidateEnum(EncounterFeedSource),
};
const Validator_EncounterFeed_ProtocolNavigation = {
    ...Validator_EncounterFeed_Base,
    itemType: tsValidateValue([EncounterFeedType.ProtocolNavigation]),
    payload: {
        itemType: tsValidateValue([EncounterFeedType.ProtocolNavigation]),
        pathwayId: tsValidateUniqueId,
        stateId: tsValidateUniqueId,
    }
};
const Validator_EncounterFeed_ProtocolConsiderationSwitch = {
    ...Validator_EncounterFeed_Base,
    itemType: tsValidateValue([EncounterFeedType.ProtocolConsiderationSwitch]),
    payload: {
        itemType: tsValidateValue([EncounterFeedType.ProtocolConsiderationSwitch]),
        protocolId: tsValidateUniqueId,
        considerationLevel: tsValidateEnum(ConsiderationGroupEnum),
    }
};
const Validator_EncounterFeed_OrderSent = {
    ...Validator_EncounterFeed_Base,
    itemType: tsValidateValue([EncounterFeedType.OrderSent]),
    payload: {
        itemType: tsValidateValue([EncounterFeedType.OrderSent]),
        runtimeId: tsValidateUniqueId,
        relatedPathwayIds: tsValidateArray(tsValidateUniqueId),
    }
};
const Validator_EncounterFeed_OrderResulted = {
    ...Validator_EncounterFeed_Base,
    itemType: tsValidateValue([EncounterFeedType.OrderResulted]),
    payload: {
        itemType: tsValidateValue([EncounterFeedType.OrderResulted]),
        runtimeId: tsValidateUniqueId,
        relatedPathwayIds: tsValidateArray(tsValidateUniqueId),
    }
};
const Validator_ModifiableProps = (i) => {
    if (!i)
        return 'Did not receive item to validate';
    switch (i.itemType) {
        case EncounterFeedType.ProtocolNavigation:
            return tsValidateResult(i, Validator_EncounterFeed_ProtocolNavigation);
        case EncounterFeedType.ProtocolConsiderationSwitch:
            return tsValidateResult(i, Validator_EncounterFeed_ProtocolConsiderationSwitch);
        case EncounterFeedType.OrderSent:
            return tsValidateResult(i, Validator_EncounterFeed_OrderSent);
        case EncounterFeedType.OrderResulted:
            return tsValidateResult(i, Validator_EncounterFeed_OrderResulted);
    }
};
const Validator_GeneratedProps = {};
export const DBDef_RuntimeEncounterFeed = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'encounter-feed',
    entityName: 'RuntimeEncounterFeed',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'encounter-feed'
    },
    backend: {
        name: 'encounter-feed'
    }
};
//# sourceMappingURL=db-def.js.map